import config from 'config';
import dbInstance from './dbInstace';

class CrossSellingApi {

	/**
	 * Build crossSelling object
	 */
	static getCMCrossSelling(game) {

		if (!game.currentQuestion) return Promise.resolve(null);

		// return this.getCMPhonogram(game, () => {
			return this.getCMArtist(game, () => {
				return this.getCMAlbum(game, () => {
					return Promise.resolve(null);
				});
			});
		// });
	}

	/**
	 * Gets phonogram from Claro Musica
	 */
	static getCMPhonogram(game, cb) {
		return cb();
		// if (!game.currentQuestion.idPhonogram && cb) return cb();

		// let params = {params: {idPhonogram: game.currentQuestion.idPhonogram}};

		// return dbInstance.get(config.core.API.routes.cmPhonogram.phonogram, params).then(response => {
		// 	if (response[0]) {
		// 		return {text: response[0].fonogramaNome, link: response[0].idFonograma};
		// 	} else {
		// 		if (cb) return cb();
		// 		return;
		// 	}
		// }).catch(err => {
		// 	console.info(err);
		// 	if (cb) return cb();
		// });
	}

	/**
	 * Gets artist from Claro Musica
	 */
	static getCMArtist(game, cb) {
		return cb();
		if (!game.currentQuestion.idArtist && cb) return cb();

		let params = {params: {idArtist: game.currentQuestion.idArtist}};		

		return dbInstance.get(config.core.API.routes.cmPhonogram.artist, params).then(response => {
			if (response[0]) {
				return {text: response[0].artistaNome, link: config.application.claroMusicaPath.artist + response[0].artistaId};
			} else {
				if (cb) return cb();
				return;
			}
		}).catch(err => {
			console.info(err);
			if (cb) return cb();
		});
	}

	/**
	 * Gets album from Claro Musica
	 */
	static getCMAlbum(game, cb) {
		return cb();
		if (!game.currentQuestion.idAlbum && cb) return cb();

		let params = {params: {idAlbum: game.currentQuestion.idAlbum}};

		return dbInstance.get(config.core.API.routes.cmPhonogram.album, params).then(response => {
			if (response[0]) {
				return {text: response[0].albumNome_original, link: config.application.claroMusicaPath.artist + response[0].albumId};
			} else {
				if (cb) return cb();
			}
		}).catch(err => {
			console.info(err);
			if (cb) return cb();
		});
	}
}

export default CrossSellingApi;


// WEBPACK FOOTER //
// ./src/api/crossSelling-api.js